import { FETCH_ALL_FAQS, FETCH_FAQ } from "../types";
import fetchService from "../../../services/fetchService";

const baseUrl = {
  backend: process.env.API_BASE_URL,
};

// FAQs are a handful of curated entries - fetch a generous limit in one
// request and skip pagination UI entirely, same approach as metrics.
const FAQS_FETCH_LIMIT = 100;

export const fetchFaqsData = (page) => async (dispatch) =>
  await dispatch({
    type: FETCH_ALL_FAQS,
    message: `All FAQs data`,
    payload: fetchService(
      `${baseUrl.backend}/api/faqs?page=${page}&limit=${FAQS_FETCH_LIMIT}`
    ),
  });

export const fetchFaqData = (id) => async (dispatch) =>
  await dispatch({
    type: FETCH_FAQ,
    message: `FAQ data`,
    payload: fetchService(`${baseUrl.backend}/api/faqs/${id}`),
  });
